import React from "react";
import { Input, Button } from "reactstrap";
import { IconSearch } from "../../Components/Icons";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  GET_FILTER_PRODUCT,
  SET_PRODUCT_DETAIL_ID,
  TOGGLE_MODAL_PRODUCT_DETAIL,
} from "../../store/actions/products";
import { LIST_PRODUCT } from "../../store/actions/cart";
import { toast } from "react-toastify";

const mapStateToProps = (state) => ({
  searchData: state.Cart.searchData,
  selectedWarehouse: state.Cart.selectedWarehouse,
});

const mapDispatchToProps = (dispatch) => ({
  GET_FILTER_PRODUCT: () => dispatch(GET_FILTER_PRODUCT()),
  LIST_PRODUCT: (lang, userId) => dispatch(LIST_PRODUCT(lang, userId)),
  TOGGLE_MODAL_PRODUCT_DETAIL: () => dispatch(TOGGLE_MODAL_PRODUCT_DETAIL()),
  SET_PRODUCT_DETAIL_ID: (payload) => dispatch(SET_PRODUCT_DETAIL_ID(payload)),
  SELECT_WAREHOUSE: (payload) =>
    dispatch({
      type: "SELECT_WAREHOUSE",
      selectedWarehouse: payload,
    }),
});

class AutoCompleted extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      text: "",
      finalArray: [],
      isSearchFocused: false,
      selectedSuggestion: null,
    };
    this.handleClickForFocus = this.handleClickForFocus.bind(this);
  }

  handleClickForFocus(e) {
    let contains = false;
    const searchboxes = document.querySelectorAll(".top-search-box");
    for (let i = 0; i < searchboxes.length; i++) {
      if (searchboxes[i].contains(e.target)) {
        contains = true;
        break;
      }
    }
    this.setState({ isSearchFocused: contains });
  }

  componentDidMount() {
    document.addEventListener("click", this.handleClickForFocus);

    this.clearSearchListener = () => {
      const defaultWarehouse = 1;
      localStorage.setItem("stockWarehouse", defaultWarehouse);
      this.props.SELECT_WAREHOUSE(defaultWarehouse);

      this.setState(
        { text: "", finalArray: [], selectedSuggestion: null },
        () => {
          this.fetchProducts();
        }
      );
    };
    document.addEventListener("clearSearchInput", this.clearSearchListener);

    const defaultWarehouse = 1;
    localStorage.setItem("stockWarehouse", defaultWarehouse);
    this.props.SELECT_WAREHOUSE(defaultWarehouse);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const defaultWarehouse = 1;
      localStorage.setItem("stockWarehouse", defaultWarehouse);
      this.props.SELECT_WAREHOUSE(defaultWarehouse);

      this.setState(
        { text: "", finalArray: [], selectedSuggestion: null },
        () => {
          this.fetchProducts();
        }
      );
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickForFocus);
    document.removeEventListener("clearSearchInput", this.clearSearchListener);
  }

  onInputFocus = () => {
    const { filterProductItem } = this.props;
    if (!filterProductItem || filterProductItem.length === 0) {
      this.props.GET_FILTER_PRODUCT();
    }
  };

  fetchProducts = () => {
    const lang = this.props.lang || "en";
    const userId = this.props.userId || null;
    this.props.LIST_PRODUCT(lang, userId);
  };

  onTextChange = (e) => {
    const value = e.target.value;

    if (value === "") {
      const defaultWarehouse = 1;
      localStorage.setItem("stockWarehouse", defaultWarehouse);
      this.props.SELECT_WAREHOUSE(defaultWarehouse);

      this.setState({ text: "", finalArray: [], selectedSuggestion: null });
      this.props.setValue("searchFilter", "");
      this.fetchProducts();
      return;
    }

    let suggestions = [];
    let regex = /^[0-9]+$/;
    if (value.match(regex) && value.length >= 3) {
      let filterData = (this.props.filterProductItem ?? []).filter((item) => {
        const firstCondition =
          item.node.matchCode.includes(value) &&
          item.node.dots &&
          item.node.dots.length > 0;
        return firstCondition;
      });

      let sortData = filterData.sort((a, b) => {
        if (a.node.loadRating < b.node.loadRating) return -1;
        if (a.node.loadRating > b.node.loadRating) return 1;
        return 0;
      });

      const match = sortData.map((o) => o.node.matchCode);
      const filtered = sortData.filter((item, index) => {
        let code = item.node.matchCode;
        return !match.includes(code, index + 1);
      });
      suggestions = filtered;
    }

    this.renderSuggestions(suggestions);
    this.setState({ text: value, selectedSuggestion: null });
    this.props.setValue("searchFilter", value);
  };

  selectedText(value) {
    this.setState(
      {
        text: value.node.matchCode,
        finalArray: [],
        selectedSuggestion: value,
      },
      () => {
        if (!this.props.selectedWarehouse) {
          const defaultWarehouse = 1;
          localStorage.setItem("stockWarehouse", defaultWarehouse);
          this.props.SELECT_WAREHOUSE(defaultWarehouse);
        }

        this.props.onSelectSearch(value.node.matchCode);
        this.props.TOGGLE_MODAL_PRODUCT_DETAIL();
        this.props.SET_PRODUCT_DETAIL_ID(value.node.id);

        this.setState({ selectedSuggestion: null });
      }
    );
    this.props.setValue("searchFilter", value.node.matchCode);
  }

  renderSuggestions = (suggestions) => {
    if (suggestions.length) {
      this.setState({ finalArray: suggestions });
    }
  };

  onSearch = () => {
    const { selectedSuggestion, text } = this.state;

    if (!this.props.selectedWarehouse) {
      const defaultWarehouse = 1;
      localStorage.setItem("stockWarehouse", defaultWarehouse);
      this.props.SELECT_WAREHOUSE(defaultWarehouse);
    }

    let filterToSearch = selectedSuggestion ? selectedSuggestion : null;

    if (!filterToSearch) {
      const filtered = (this.props.filterProductItem ?? []).find(
        (item) => item.node.matchCode === text
      );
      if (filtered) filterToSearch = filtered;
    }

    if (filterToSearch) {
      this.props.onSelectSearch(filterToSearch.node.matchCode);
      this.props.TOGGLE_MODAL_PRODUCT_DETAIL();
      this.props.SET_PRODUCT_DETAIL_ID(filterToSearch.node.id);
    }

    this.setState({ selectedSuggestion: null });
  };

  searchFunction = () => {
    this.onSearch();
  };

  render() {
    const { text } = this.state;
    const { t } = this.props;

    return (
      <div id="notebooks">
        <div className="dropdown-and-search-container">
          {/* <select className="dropdown warehouse-dropdown" value={1} disabled>
            <option value={1}>Fujairah</option>
          </select> */}
 <select
            className="dropdown warehouse-dropdown"
            onChange={(e) => {
              localStorage.setItem("stockWarehouse",e.target.value);
              this.props.SELECT_WAREHOUSE(
                e.target.value === "Warehouse" ? undefined : e.target.value
              );
               this.onSearch();
                this.setState({ text:   localStorage.getItem('searchFilterText' ) });
              
            }}
          >
            <option
              value={undefined}
              selected={this.props.selectedWarehouse === undefined}
            >
              Warehouse
            </option>
            {[
              {
                id: 1,
                name: "Fujairah",
              },
              // {
              //   id: 2,
              //   name: "Abudhabi",
              // },
              {
                id: 3,
                name: "Dubai",
              },
              // {
              //   id: 4,
              //   name: "Alain",
              // },
            ].map((item, index) => (
              <option
                key={index}
                value={item.id}
                selected={this.props.selectedWarehouse === item.id}
              >
                {item.name}
              </option>
            ))}
          </select>
          <Input
            id="query"
            type="tel"
            autoComplete="off"
            onFocus={this.onInputFocus}
            onChange={this.onTextChange}
            onKeyDown={(e) => e.key === "Enter" && this.searchFunction()}
            value={text}
            placeholder={t("topHeader.productSearch")}
          />
        </div>

        <Button
          color="primary"
          className="search-btn rounded-pill"
          onClick={this.searchFunction}
        >
          <IconSearch />
        </Button>

        {this.state.isSearchFocused && this.state.finalArray.length > 0 && (
          <ul className="suggestions">
            {this.state.finalArray.map((item, index) => (
              <li
                key={index}
                style={{ cursor: "pointer" }}
                onClick={() => this.selectedText(item)}
              >
                {item.node.matchCode}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}

export default withRouter(
  withTranslation()(connect(mapStateToProps, mapDispatchToProps)(AutoCompleted))
);
